/**
 * Helps COD / checkout apps recover after AJAX cart morphs and on full page lifecycle.
 *
 * Listening to Theme `cart:update` catches every CartAddEvent + CartUpdateEvent (qty, discounts),
 * since morphSection alone may race late-binding vendor scripts.
 */
import { ThemeEvents } from '@theme/events';
import { notifyThirdPartyCartScripts } from '@theme/section-renderer';

/** @returns {HTMLElement} */
function pageScope() {
  return /** @type {HTMLElement} */ (document.getElementById('header-group') ?? document.body);
}

function burst() {
  notifyThirdPartyCartScripts(pageScope());
}

// Extra retries for COD apps that finish async initialization > 600 ms after their script loads.
// 500 ms covers apps that initialize just after window.load.
// 1500 ms covers apps that make an API call during init.
// 3000 ms covers slow mobile connections or apps with multi-step async bootstrap.
function burstAndRetry() {
  burst();
  setTimeout(burst, 500);
  setTimeout(burst, 1500);
  setTimeout(burst, 3000);
}

// DOMContentLoaded: catches apps already present in the DOM before all resources finish.
document.addEventListener('DOMContentLoaded', burst);
// load: fires after every external script (including the COD app) has executed — main fix for
// the "button disappears on refresh" case where the app initializes after DOMContentLoaded.
window.addEventListener('load', burstAndRetry);
// pageshow: covers bfcache restores and View Transition navigations (load does not fire then).
window.addEventListener('pageshow', burstAndRetry);
document.addEventListener(ThemeEvents.cartUpdate, burst);
